/* eslint-disable @typescript-eslint/no-unused-vars */
import { Col, Row } from '@app/components'
import { MenuOutlined } from '@app/components/icons'
import { IStore } from '@app/redux'
import RainbowKitButton from 'libs/services/new_wallet/RainbowKitButton'
import { useSelector } from 'react-redux'

import { CoastWordMarkIcon } from '~public'

import { MenuToggleButton, StyledPageHeader, StyledSpace } from './elements'

export const NavBar = ({
  showMenuToggle = false,
  sidebarCollapsed = false,
  onToggleSidebar,
}: {
  showMenuToggle?: boolean
  sidebarCollapsed?: boolean
  onToggleSidebar?: () => void
}) => {
  const { theme } = useSelector((state: IStore) => state)

  return (
    <StyledPageHeader
      isNavbar
      title={
        <>
          {showMenuToggle && (
            <MenuToggleButton
              type="button"
              aria-label={sidebarCollapsed ? 'Expand menu' : 'Collapse menu'}
              aria-expanded={!sidebarCollapsed}
              onClick={onToggleSidebar}
            >
              <MenuOutlined />
            </MenuToggleButton>
          )}
          <CoastWordMarkIcon />
        </>
      }
      extra={
        <Row justify={'end'}>
          <Col span={24}>
            <StyledSpace size="large">
              <RainbowKitButton />
            </StyledSpace>
          </Col>
        </Row>
      }
    />
  )
}
